"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var toAbsolute_exports = {};
__export(toAbsolute_exports, {
  toAbsolute: () => toAbsolute,
  toAbsoluteUrl: () => toAbsoluteUrl
});
module.exports = __toCommonJS(toAbsolute_exports);
var import_path = require("path");
var import_url = require("url");
var toAbsolute = function(p) {
  return (0, import_path.resolve)(process.cwd(), p);
};
var toAbsoluteUrl = function(p) {
  return (0, import_url.pathToFileURL)((0, import_path.resolve)(process.cwd(), p)).href;
};
//# sourceMappingURL=toAbsolute.js.map
